// ─────────────────────────────────────────────────────────────────────────────
// "FINISH SETTING UP" — EXACTLY WHAT IS LEFT, ONE ROW PER ITEM (push C).
//
// The rows are the server's (utils/partnerReadiness.forPartner): the same
// list every partner gate refuses with and the same checklist DoorlyDesk shows
// staff. Nothing here decides what is outstanding.
//
// 🔑 EVERY ROW HAS ITS OWN WAY FORWARD. A partner item has a button to the
// place it is done, carrying ?return= so the partner comes back to where she
// started; a Doorly item says so ("Doorly is doing this — no action needed")
// and has no button. One "Pick up where I left off" button for a list of three
// is how Korinne landed on a dashboard with nothing to do.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';

const CTA = {
  agreement: 'Sign now',
  training: 'Start training',
  licence: 'Update license',
  wrong_product: 'Open',
};

/** `where` may already carry a query (e.g. ?training=1). */
export function withReturn(where, returnTo) {
  if (!where) return null;
  if (!returnTo) return where;
  const sep = where.includes('?') ? '&' : '?';
  return `${where}${sep}return=${encodeURIComponent(returnTo)}`;
}

export default function ReadinessChecklist({ missing, notice, returnTo, testId = 'readiness-checklist' }) {
  const rows = Array.isArray(missing) ? missing : [];
  if (!rows.length && !notice) return null;
  return (
    <div data-testid={testId}>
      {rows.length > 0 && (
        <ul style={{ listStyle: 'none', margin: '0 0 12px', padding: 0 }}>
          {rows.map((t) => {
            const href = t.who === 'partner' ? withReturn(t.where, returnTo) : null;
            return (
              <li key={t.key} data-testid={`readiness-item-${t.key}`} data-who={t.who}
                style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                  gap: 12, padding: '10px 0', borderTop: '1px solid #f3f4f6' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{t.label}</div>
                  {t.detail && (
                    <div style={{ fontSize: 12.5, color: '#6b7280', lineHeight: 1.55, marginTop: 2 }}>{t.detail}</div>
                  )}
                  {t.who !== 'partner' && (
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                      {t.cta || 'Doorly is doing this — no action needed'}
                    </div>
                  )}
                </div>
                {href && (
                  <button type="button" data-testid={`readiness-go-${t.key}`}
                    onClick={() => { window.location.href = href; }}
                    style={{ flexShrink: 0, padding: '8px 14px', background: '#3a6ad9', color: '#fff',
                      border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
                    {CTA[t.key] || 'Continue'}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {notice && !rows.some((t) => t.key === 'licence' || t.key === 'firm_licence') && (
        <p style={{ fontSize: 13, color: '#374151', lineHeight: 1.7, background: '#eff6ff',
          border: '1px solid #bfdbfe', borderRadius: 8, padding: '9px 12px', margin: '0 0 12px' }}>
          {notice}
        </p>
      )}
    </div>
  );
}
